import XLogo from "@/images/prime_twitter.svg";
import contactImage from "@/images/contact_image.png";
import { Logo } from "@/components/lib";

export function Contact() {
  return (
    <div className="flex flex-col gap-4 lg:gap-8 text-left lg:text-center text-white">
      <Logo className="w-48 lg:w-64 mx-auto my-5 sm:mt-0 lg:hidden" />

      <div className="relative w-full overflow-hidden shadow-lg pb-4">
        <img
          src={contactImage}
          alt="Grapevine High School"
          className="w-full h-96 lg:h-[85vh] object-cover opacity-20"
        />

        <div
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(180deg, rgba(7, 16, 27, 0) 18.3%, #07101B 100%)"
          }}
        />

        <div className="absolute bottom-0 lg:top-1/2 lg:-translate-y-1/4 lg:left-1/2 lg:-translate-x-1/2 p-6 text-white">
          <p className="font-bold text-3xl lg:text-7xl">
            Grapevine High School
          </p>
          <p className="text-sm mt-2 lg:text-2xl">
            3050 Mustang Drive, Grapevine, TX 76051
          </p>
          <div className="hidden lg:block text-2xl mt-10">
            <h2 className="mb-10">
              To contact our recruiting coordinator, please email:{" "}
              <a
                href="mailto:Ryan.Smith@GCISD.net"
                className="text-[#CF2027] font-bold"
              >
                Ryan.Smith@GCISD.net
              </a>
            </h2>
            <div className="flex gap-4 justify-center">
              <a
                href="https://x.com/GHSMustangsFB"
                target="_blank"
                rel="noreferrer"
              >
                <img src={XLogo} alt="X" className="w-18" />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-3 mx-4 lg:hidden">
        <h2>
          To contact our recruiting coordinator, please email:{" "}
          <br className="lg:hidden" />
          <a
            href="mailto:Ryan.Smith@GCISD.net"
            className="text-[#CF2027] font-bold"
          >
            Ryan.Smith@GCISD.net
          </a>
        </h2>
        <h3>Follow Us</h3>
        <a href="https://x.com/GHSMustangsFB" target="_blank" rel="noreferrer">
          <img src={XLogo} alt="X" className="w-18" />
        </a>
      </div>
    </div>
  );
}
